var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"key",class:{ sharp: _vm.sharp, vanilla: _vm.vanillaFriendly, selected: _vm.selected },on:{"click":_vm.select}},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }